<template>
  <!-- Tela de Envio de Mensagens -->
  <div class="content">
    <!-- Frame da Esquerda (Inclusão de Números) -->
    <div class="frame left-frame">
      <h4 class="cnpj-section-title">INCLUIR TELEFONES</h4>
      <p class="cnpj-section-subtitle">
        Insira aqui os numeros com código do país (DDI) + DDD ex: 5581 ...
      </p>

      <!-- Campo para inclusão de números manualmente -->
      <div class="interval-group-container">
        <div class="input-group-msg">
          <label for="newName">Nome:</label>
          <input v-model="newName" type="text" placeholder="Ex: João" />
        </div>
        <div class="input-group-msg">
          <label for="newNumber">Número:</label>
          <input
            v-model="newNumber"
            type="text"
            placeholder="Ex: 558199887766"
          />
        </div>
        <button
          class="small-button"
          @click="addNumber"
          style="height: 34px; margin-top: 25px"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 13.1429H13.1429V20H10.8571V13.1429H4V10.8571H10.8571V4H13.1429V10.8571H20V13.1429Z"
              fill="#4D5163"
            />
          </svg>
          Adicionar
        </button>
      </div>

      <section
        v-if="numbers.length"
        class="contact-analysis"
        :aria-busy="analysisProgress.pending > 0"
        aria-label="Progresso da análise dos contatos"
      >
        <div class="contact-analysis__heading" role="status" aria-live="polite">
          <span v-if="analysisProgress.pending" class="contact-analysis__spinner" aria-hidden="true"></span>
          <strong>{{ analysisProgress.pending ? 'Analisando contatos…' : 'Análise finalizada' }}</strong>
          <span>{{ analysisProgress.completed }} / {{ analysisProgress.total }} verificações finalizadas</span>
        </div>
        <progress
          class="contact-analysis__progress"
          :value="analysisProgress.completed"
          :max="analysisProgress.total"
          aria-label="Verificações finalizadas"
        ></progress>
        <div class="contact-analysis__details">
          <span>WhatsApp: {{ analysisProgress.whatsapp }} / {{ numbers.length }}</span>
          <span>Histórico: {{ analysisProgress.history }} / {{ numbers.length }}</span>
        </div>
        <p v-if="analysisProgress.pending" class="contact-analysis__hint">
          Aguarde. O progresso é atualizado quando cada consulta retorna.
        </p>
        <p v-else-if="analysisProgress.unconfirmed" class="contact-analysis__hint">
          {{ analysisProgress.unconfirmed }} verificação(ões) sem confirmação. Confira os resultados na lista.
        </p>
      </section>



      <!-- Tabela com números de telefone -->
      <div
        class="table-container-Message"
        :class="{ 'is-empty': numbers.length === 0 }"
      >
      <div class="table-scroll">
        <table
          v-if="numbers.length > 0 || numbers.length === 0"
          class="tableClients table-numbers"
        >
          <thead>
            <tr>
              <th>Nome</th>
              <th>Número</th>
              <th>WhatsApp</th>
              <th>Contato</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(num, index) in pagedNumbers" :key="num.number + ':' + index">
              <td>{{ num.name }}</td>
              <td>{{ num.number }}</td>

              <!-- WhatsApp -->
              <td>
                <span
                  v-if="num.checkingWhatsApp === true"
                  class="contact-badge contact-badge--loading"
                >
                  <span class="contact-badge__dot"></span>
                  Checando…
                </span>

                <span v-else-if="num.hasWhatsapp === null" class="contact-badge contact-badge--muted">
                  Não foi possível confirmar
                </span>

                <span
                  v-else-if="num.hasWhatsapp === true"
                  class="contact-badge contact-badge--success"
                >
                  <span class="contact-badge__dot"></span>
                  Tem WhatsApp
                </span>

                <span
                  v-else
                  class="contact-badge contact-badge--danger"
                >
                  <span class="contact-badge__dot"></span>
                  Sem WhatsApp
                </span>
              </td>

              <!-- Contato (Histórico) -->
              <td>
                <span
                  v-if="num.checkingHistory === true"
                  class="contact-badge contact-badge--loading"
                >
                  <span class="contact-badge__dot"></span>
                  Checando…
                </span>

                <span v-else-if="num.hasHistory === null" class="contact-badge contact-badge--muted">
                  Não foi possível consultar
                </span>

                <span
                  v-else-if="num.hasHistory === true"
                  class="contact-badge contact-badge--warn"
                >
                  <span class="contact-badge__dot"></span>
                  Já contatado
                </span>

                <span
                  v-else
                  class="contact-badge contact-badge--muted"
                >
                  <span class="contact-badge__dot"></span>
                  Sem histórico
                </span>
              </td>

              <!-- Ação (Remover) -->
              <td>
                <button class="remove-button" @click="removeNumber(globalIndex(index))">
                  Remover
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

        <!-- Paginação -->
        <div v-if="numbers.length > pageSize" class="pagination">
          <p class="record-count">{{ numbers.length }} contato(s)</p>

          <div class="pagination-pages">
            <button
              class="pagination-button"
              :disabled="page === 1"
              @click="page--"
              aria-label="Página anterior"
            >
              «
            </button>

            <span class="page-label">Página</span>
            <span class="page-current">{{ page }}</span>

            <span class="page-info">de {{ totalPages }}</span>

            <button
              class="pagination-button"
              :disabled="page === totalPages"
              @click="page++"
              aria-label="Próxima página"
            >
              »
            </button>
          </div>
        </div>

        <!-- Overlay visual quando a lista estiver vazia -->
        <div v-if="numbers.length === 0" class="table-empty-overlay">
          <div class="empty-icon"><i class="fab fa-whatsapp"></i></div>
          <div class="empty-title">Nenhum número cadastrado</div>
          <div class="empty-sub">Adicione manualmente ou importe um CSV.</div>
        </div>
      </div>

      <div class="export-container" style="margin-top: 1%">
        <input type="file" id="csvFile" accept=".csv" style="display: none" />
        <button class="small-button" @click="importCSV">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.0013 9.07464H9.07464V4.0013H16.0013V9.58797H17.3346V4.0013C17.3346 3.64768 17.1942 3.30854 16.9441 3.05849C16.6941 2.80844 16.3549 2.66797 16.0013 2.66797H7.24797L2.66797 7.24797V20.0013C2.66797 20.3549 2.80844 20.6941 3.05849 20.9441C3.30854 21.1942 3.64768 21.3346 4.0013 21.3346H16.0013C16.3549 21.3346 16.6941 21.1942 16.9441 20.9441C17.1942 20.6941 17.3346 20.3549 17.3346 20.0013H4.0013V9.07464ZM4.0013 7.79463L7.79464 4.0013H8.0013V8.0013H4.0013V7.79463Z"
              fill="#4D5163"
            />
            <path
              d="M18.8787 10.9025C18.7512 10.7933 18.5871 10.7362 18.4193 10.7427C18.2515 10.7492 18.0924 10.8187 17.9737 10.9375C17.8549 11.0562 17.7854 11.2153 17.7789 11.3831C17.7724 11.5509 17.8295 11.715 17.9387 11.8425L20.1054 14.0025H11.9987C11.8219 14.0025 11.6523 14.0727 11.5273 14.1978C11.4023 14.3228 11.332 14.4923 11.332 14.6692C11.332 14.846 11.4023 15.0155 11.5273 15.1406C11.6523 15.2656 11.8219 15.3358 11.9987 15.3358H20.1254L17.9387 17.5225C17.8689 17.5823 17.8122 17.6558 17.7722 17.7385C17.7322 17.8212 17.7097 17.9113 17.7062 18.0031C17.7026 18.0949 17.7181 18.1865 17.7516 18.272C17.7851 18.3576 17.836 18.4353 17.9009 18.5003C17.9659 18.5652 18.0436 18.6161 18.1291 18.6496C18.2147 18.6831 18.3063 18.6986 18.3981 18.695C18.4899 18.6915 18.58 18.669 18.6627 18.629C18.7454 18.589 18.8189 18.5323 18.8787 18.4625L22.6654 14.6692L18.8787 10.9025Z"
              fill="#4D5163"
            />
          </svg>

          Carregar CSV
        </button>
        <button class="small-button" @click="clearList">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.1368 20.3624H7.85684C6.80984 20.3624 5.93984 19.6442 5.86184 18.7153L4.96484 7.91797H18.9988L18.1318 18.7109C18.0568 19.6415 17.1858 20.3624 16.1368 20.3624V20.3624Z"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 11.4727V16.806"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4 7.9171H20"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 7.91884L15.987 5.51706C15.694 4.82284 14.948 4.36328 14.114 4.36328H9.886C9.052 4.36328 8.306 4.82284 8.013 5.51706L7 7.91884"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.43 11.4727L15 16.806"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.57016 11.4727L9.00016 16.806"
              stroke="#4D5163"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Limpar Lista
        </button>
      </div>
    </div>

    <!-- Frame da Direita (Mensagem e Envio) -->
    <div class="frame right-frame">
      <h4 class="cnpj-section-title">ENVIAR MENSAGEM</h4>
      <p class="cnpj-section-subtitle">
        Após inserir os números para envio, digite abaixo a mensagem que deseja
        enviar para os numeros selecionados
      </p>

      <!-- Campo de mensagem -->
      <!-- label for="message">Mensagem:</label -->
      <textarea
        v-model="message"
        placeholder="Digite a mensagem: Use {nome} para personalizar o nome no envio.

        Exemplo:

        Olá, {nome}! Temos uma oferta especial. Gostaria de saber mais?"
        rows="19"
      ></textarea>

      <!-- Intervalo entre mensagens -->
      <div class="interval-container-msg">
        <label for="interval">Intervalo (segundos):</label>
        <input
          v-model="interval"
          type="number"
          placeholder="Intervalo entre mensagens"
          min="4"
        />

        <!-- Campo Limite Diário -->
        <label for="dailyLimit">Restante hoje:</label>

        <input
          v-if="!dailyRemainingLoading"
          :value="dailyRemaining"
          type="text"
          readonly
        />

        <div v-else class="daily-remaining-loading">
          <span class="spinner-small"></span>
          <span>Calculando…</span>
        </div>

        <div class="media-button-row">
          <button class="small-button" @click="selectImage">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="4" width="14" height="12" rx="2" ry="2" />

              <circle cx="9" cy="9" r="1.4" />

              <path d="M5.5 14.5l3-3 2.5 2.5 2-2.5 3 3" />

              <circle cx="18" cy="18" r="3.2" />

              <path d="M18 16.2v3.2" />
              <path d="M16.8 17.4L18 16.2l1.2 1.2" />
            </svg>

            Inserir Imagem
          </button>
          <button
            v-if="!isRecording"
            class="small-button"
            @click="startRecording"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="9" y="5" width="6" height="9" rx="3" ry="3" />
              <path d="M8 11a4 4 0 0 0 8 0" />
              <path d="M12 15v3.5" />
              <path d="M10 18.5h4" />
              <circle cx="18" cy="18" r="3.2" />
              <path d="M18 16.2v3.2" />
              <path d="M16.8 17.4L18 16.2l1.2 1.2" />
            </svg>
            Gravar Áudio
          </button>
          <button
            v-if="isRecording"
            class="small-button stop"
            @click="stopRecording"
          >
            ⏹️ Parar Gravação
          </button>
        </div>

        <!-- Input escondido para upload de imagem -->
        <input
          type="file"
          ref="imageInput"
          accept="image/*"
          style="display: none"
          @change="handleImageUpload"
        />
      </div>

      <!-- 🔹 Preview da imagem selecionada -->
      <div v-if="imagePreview" class="image-preview">
        <img :src="imagePreview" alt="Imagem selecionada" />
        <button type="button" class="remove-image-button" @click="removeImage">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="remove-icon">
            <path
              d="M6 6l12 12M6 18L18 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Remover</span>
        </button>
      </div>

      <div v-if="audioPreview" class="audio-preview">
        <audio :src="audioPreview" controls></audio>
        <button type="button" class="remove-audio-button" @click="removeAudio">
          <svg viewBox="0 0 24 24" aria-hidden="true" class="remove-icon">
            <path
              d="M6 6l12 12M6 18L18 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Remover</span>
        </button>
      </div>

      <!-- Botão Enviar -->
      <button
        class="small-button"
        @click="sendMessage"
        style="margin-top: 1%"
        :disabled="isSending"
      >
        <!-- Estado normal -->
        <span v-if="!isSending" class="btn-content">
          <svg
            width="32"
            height="28"
            viewBox="0 0 32 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.9604 6.76562V14.5933"
              stroke="#040101"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22.9604 6.76562V14.5933"
              stroke="black"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.0794 21.31H17.3594"
              stroke="#040101"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M24.0794 21.31H17.3594"
              stroke="black"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.8398 19.0703L24.0798 21.3103L21.8398 23.5503"
              stroke="#040101"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.8398 19.0703L24.0798 21.3103L21.8398 23.5503"
              stroke="black"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.8799 19.0733H6.15992C4.92232 19.0733 3.91992 18.0709 3.91992 16.8333V6.76562"
              stroke="#040101"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.8799 19.0733H6.15992C4.92232 19.0733 3.91992 18.0709 3.91992 16.8333V6.76562"
              stroke="black"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.17224 4.51172H20.7087C21.9519 4.51172 22.961 5.51972 22.961 6.76404V6.76404C22.961 7.51108 22.5903 8.20884 21.9721 8.62772L15.9722 12.6944C14.4434 13.7304 12.4364 13.7304 10.9076 12.6944L4.90888 8.62884C4.29064 8.20996 3.91992 7.51108 3.91992 6.76516V6.76404C3.91992 5.51972 4.92792 4.51172 6.17224 4.51172Z"
              stroke="#040101"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.17224 4.51172H20.7087C21.9519 4.51172 22.961 5.51972 22.961 6.76404V6.76404C22.961 7.51108 22.5903 8.20884 21.9721 8.62772L15.9722 12.6944C14.4434 13.7304 12.4364 13.7304 10.9076 12.6944L4.90888 8.62884C4.29064 8.20996 3.91992 7.51108 3.91992 6.76516V6.76404C3.91992 5.51972 4.92792 4.51172 6.17224 4.51172Z"
              stroke="black"
              stroke-opacity="0.2"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Enviar</span>
        </span>

        <!-- Estado "enviando..." -->
        <span v-else class="btn-loading">
          <span class="spinner"></span>
          <span>Enviando...</span>
        </span>
      </button>

      <div v-if="statusMessage" :class="statusClass">
        {{ statusMessage }}
      </div>

      <details v-if="rejectedCSVContacts.length" class="csv-rejections" open>
        <summary>Contatos recusados no último CSV ({{ rejectedCSVContacts.length }})</summary>
        <p>Estes contatos não foram adicionados. Corrija os dados no arquivo e importe novamente.</p>
        <div class="csv-rejections__scroll">
          <table class="csv-rejections__table">
            <thead>
              <tr><th scope="col">Linha</th><th scope="col">Nome</th><th scope="col">Telefone original</th><th scope="col">Motivo</th></tr>
            </thead>
            <tbody>
              <tr v-for="contact in rejectedCSVContacts" :key="contact.line">
                <td>{{ contact.line }}</td>
                <td>{{ contact.name || 'Não informado' }}</td>
                <td>{{ contact.number || 'Não informado' }}</td>
                <td>{{ contact.reason }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </details>
    </div>
  </div>

  <!-- ✅ Modal de resultado do envio (MagLeads) -->
  <div v-if="showSentModal" class="mag-modal__overlay" @click.self="closeSentModal">
    <div class="mag-modal__card" role="dialog" aria-modal="true" aria-label="Resumo do envio">
      <div class="mag-modal__header">
        <div class="mag-modal__title">
          <span class="mag-modal__icon">✅</span>

          <span class="mag-modal__titleText">Envio concluído</span>

          <span class="mag-modal__pill">
            {{ sentSuccessList.length }} confirmado(s)
          </span>
        </div>

        <button class="mag-modal__close" type="button" @click="closeSentModal" aria-label="Fechar">
          <span class="mag-modal__closeIcon">✕</span>
        </button>
      </div>

      <div class="mag-modal__body">
        <p class="mag-modal__hint">
          Confirmação de envio: os contatos abaixo tiveram a entrega registrada com sucesso pelo sistema.
        </p>

        <div v-if="sentSuccessList.length" class="mag-modal__list">
          <div
            v-for="(c, i) in sentSuccessList"
            :key="c.number + ':' + i"
            class="mag-modal__row"
          >
            <div class="mag-modal__name">{{ c.name || "Cliente" }}</div>
            <div class="mag-modal__number">{{ c.number }}</div>
          </div>
        </div>

        <div v-else class="mag-modal__empty">
          Nenhum envio foi confirmado como sucesso.
        </div>

        <div v-if="sentFailList.length" class="mag-modal__fails">
          <div class="mag-modal__failsTitle">⚠️ Falhas ({{ sentFailList.length }})</div>
          <div class="mag-modal__failsList">
            <div v-for="(f, i) in sentFailList" :key="f.number + ':' + i" class="mag-modal__failRow">
              <span class="mag-modal__failNumber">{{ f.number }}</span>
              <span class="mag-modal__failError">{{ f.error || "Falha no envio" }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mag-modal__footer">
        <button class="mag-modal__btn mag-modal__btn--primary" type="button" @click="goToAtendimento">
          Ir para Atendimento
        </button>
        <button class="mag-modal__btn mag-modal__btn--ghost" type="button" @click="closeSentModal">
          Fechar
        </button>
      </div>
    </div>
  </div>

  <!-- Exibição do QR Code -->
  <div v-if="qrCode">
    <h3>Escaneie o QR Code com o WhatsApp:</h3>
    <img :src="qrCode" alt="QR Code" />
  </div>

  <WhatsappBlocker v-if="!whatsappAutenticado" />
</template>

<script>
import { getAuth } from "firebase/auth";
import { secureFetch } from "@/main.js";
import WhatsappBlocker from "@/components/WhatsappBlocker.vue";
import { logout } from "@/utils/sessionUtils";

function storageKey(key, uid) {
  return `magleads:${uid}:${key}`;
}
async function getUid() {
  const auth = getAuth();
  const user = auth.currentUser;
  return user?.uid || "anonymous";
}

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL || "https://177.36.4.221:3000";

export default {
  components: {
    WhatsappBlocker,
  },
  emits: ["add-card-to-kanban"],

  computed: {
    analysisProgress() {
      const whatsapp = this.numbers.filter((n) => n.checkingWhatsApp !== true).length;
      const history = this.numbers.filter((n) => n.checkingHistory !== true).length;
      
      const total = this.numbers.length * 2;
      const completed = whatsapp + history;
      
      const unconfirmed = this.numbers.reduce((count, n) => count
        + (n.checkingWhatsApp !== true && n.hasWhatsapp === null ? 1 : 0)
        + (n.checkingHistory !== true && n.hasHistory === null ? 1 : 0), 0);
      
      return { 
        whatsapp, 
        history, 
        total, 
        completed, 
        pending: total - completed, 
        unconfirmed, 
      };
    },
    pagedNumbers() {
      const start = (this.page - 1) * this.pageSize;
      return this.numbers.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.numbers.length / this.pageSize));
    },
    asyncWhatsappStatus() {
      return this.waReadyFlag === true;
    },
    whatsappAutenticado() {
      const uid = this.uidCache || "anonymous";
      const a =
        localStorage.getItem(storageKey("acessoComWhatsapp", uid)) === "true";
      const q =
        localStorage.getItem(storageKey("qrCodeScanned", uid)) === "true";

      const aLegacy = localStorage.getItem("acessoComWhatsapp") === "true";
      const qLegacy = localStorage.getItem("qrCodeScanned") === "true";

      return (a && q) || (aLegacy && qLegacy) || this.asyncWhatsappStatus;
    },
  },

  data() {
    return {
      newName: "",
      newNumber: "",
      message: "",
      page: 1,
      pageSize: 7,
      messages: [],
      contacts: [],
      rejectedCSVContacts: [],
      numbers: [],    
      audioChunks: [],
      hasWhatsapp: null,
      checkingWhatsApp: true,
      interval: 4,
      dailyLimit: 200,
      dailyRemaining: null,    
      dailyRemainingLoading: true,   
      imageFile: null,
      imagePreview: null,
      isRecording: false,
      audioBlob: null,
      audioPreview: null,
      mediaRecorder: null,
      historyCheckTimer: null,
      statusMessage: "",
      statusClass: "",
      waReadyFlag: false,
      uidCache: null,
      isSending: false,
      showSentModal: false,
      sentSuccessList: [],
      sentFailList: [],
    };
  },

  async mounted() {
    this.uidCache = await getUid();
    window.addEventListener("storage", this.onStorageChange);
    this.ensureWhatsAppReady();
    this.loadDailyRemaining();
    this.loadPreparedContacts();
    //this.resetContacts();
  },

  beforeUnmount() {
    window.removeEventListener("storage", this.onStorageChange);
  },

  methods: {
    closeSentModal() {
      this.showSentModal = false;
    },
    goToAtendimento() {
      this.showSentModal = false;
      this.$router.push("/kanban");
    },
    globalIndex(localIndex) {
      return (this.page - 1) * this.pageSize + localIndex;
    },
    ensureValidPage() {
      const tp = Math.max(1, Math.ceil(this.numbers.length / this.pageSize));
      if (this.page > tp) this.page = tp;
      if (this.page < 1) this.page = 1;
    },    
    async loadPreparedContacts() {
      try {
        const uid = this.uidCache || (await getUid());
        const raw =
          localStorage.getItem(storageKey("preparedContacts", uid)) ||
          localStorage.getItem("preparedContacts");

        if (!raw) return;

        const list = JSON.parse(raw);
        if (!Array.isArray(list) || !list.length) return;

        // joga para a lista e agenda o check de histórico
        this.numbers = list.map((c) => ({
          name: c.name,
          number: c.number,
          hasHistory: false,
          lastHistoryTs: null,
          checkingHistory: true,
          hasWhatsapp: null,
          checkingWhatsApp: true,
        }));

        // limpa para não reimportar sempre
        localStorage.removeItem(storageKey("preparedContacts", uid));
        localStorage.removeItem("preparedContacts");

        this.scheduleChecks();
        console.log("✅ Contatos carregados na tela Mensagens:", this.numbers.length);
      } catch (e) {
        console.warn("Falha ao carregar preparedContacts:", e.message);
      }
    },
    resetContacts() {
      this.numbers = [];
      this.newName = "";
      this.newNumber = "";
    },
    to55(raw) {
      let s = String(raw || "").replace(/\D/g, "");
      if (!s) return null;
      if (s.startsWith("0800")) return null;
      if (s.startsWith("0") && s.length >= 11) s = s.slice(1);
      if (s.startsWith("55")) return s.length >= 12 ? s : null;
      if (s.length >= 10) return `55${s}`;
      return null;
    },
    scheduleChecks() {
      clearTimeout(this.historyCheckTimer);
      this.historyCheckTimer = setTimeout(() => {
        this.checkHistoryForAllNumbers();
        this.checkWhatsappForAllNumbers();
      }, 350);
    },
    onStorageChange(e) {
      if (
        e.key?.includes("magleads:") ||
        e.key === "qrCodeScanned" ||
        e.key === "acessoComWhatsapp"
      ) {
        const uid = this.uidCache || "anonymous";
        const a =
          localStorage.getItem(storageKey("acessoComWhatsapp", uid)) === "true";
        const q =
          localStorage.getItem(storageKey("qrCodeScanned", uid)) === "true";
        this.waReadyFlag = a && q;
        this.$forceUpdate();
      }
    },
    async checkHistoryForAllNumbers() {
      try {
        if (!Array.isArray(this.numbers) || this.numbers.length === 0) return;

        // pega apenas os que ainda estão "checking"
        const toCheck = this.numbers.filter(
          (n) => n?.number && n.checkingHistory === true
        );
        if (!toCheck.length) return;

        // normalize (ideal: mesmo padrão do backend; se você tiver to55, use)
        const phones = Array.from(
          new Set(
            toCheck
              .map((n) => String(n.number || "").replace(/\D/g, ""))
              .filter(Boolean)
          )
        );

        if (!phones.length) return;

        const resp = await secureFetch(`${apiBaseUrl}/check-contact-history`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phones }),
        });

        if (!resp?.ok) throw new Error(resp ? `HTTP ${resp.status}` : "API sem resposta");

        const data = await resp.json();
        if (!data?.success || !Array.isArray(data.results)) {
          throw new Error(data?.message || "Resposta inválida na consulta de histórico");
        }

        // mapa por phone normalizado
        const map = new Map();
        (data.results || []).forEach((r) => {
          const k = String(r.phone || "").replace(/\D/g, "");
          if (k) map.set(k, r);
        });

        this.numbers = this.numbers.map((n) => {
          // quem não está sendo checado NÃO muda
          if (!n?.number || n.checkingHistory !== true) return n;

          const phoneNorm = String(n.number || "").replace(/\D/g, "");
          const hit = map.get(phoneNorm);

          return {
            ...n,
            checkingHistory: false,
            hasHistory: typeof hit?.hasHistory === "boolean" ? hit.hasHistory : null,
            lastHistoryTs: hit?.lastTs || null,
          };
        });
      } catch (e) {
        console.warn("Falha ao checar histórico:", e?.message || e);

        // só tira o loading de quem estava checando
        this.numbers = this.numbers.map((n) =>
          n?.checkingHistory ? { ...n, checkingHistory: false, hasHistory: null } : n
        );
      }
    },
    async checkWhatsappForAllNumbers() {
      try {
        if (!this.numbers.length) return;

        const toCheck = this.numbers.filter(
          (n) => n?.number && n.checkingWhatsApp === true
        );

        if (!toCheck.length) return;

        const phones = toCheck
          .map((n) => this.to55(n.number))
          .filter(Boolean);

        if (!phones.length) return;

        const resp = await secureFetch(`${apiBaseUrl}/check-whatsapp-batch`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phones }),
        });

        if (!resp?.ok) throw new Error(resp ? `HTTP ${resp.status}` : "API sem resposta");
        const data = await resp.json();
        if (!data?.success || !Array.isArray(data.results)) {
          throw new Error(data?.message || "Resposta inválida na consulta de WhatsApp");
        }

        const map = new Map();

        // chave = INPUT (o mesmo que você enviou)
        (data.results || []).forEach((r) => {
          const k = String(r.input || "").replace(/\D/g, "");
          if (k) map.set(k, r);
        });

        this.numbers = this.numbers.map((n) => {
          if (!n?.number || n.checkingWhatsApp !== true) return n;

          const key = String(this.to55(n.number) || "").replace(/\D/g, "");
          const hit = map.get(key);

          return {
            ...n,
            checkingWhatsApp: false,
            hasWhatsapp: typeof hit?.hasWhatsapp === "boolean" ? hit.hasWhatsapp : null,
          };
        });
      } catch (e) {
        console.warn("Falha ao checar WhatsApp:", e.message);
        this.numbers = this.numbers.map((n) =>
          n?.checkingWhatsApp ? { ...n, checkingWhatsApp: false, hasWhatsapp: null } : n
        );
      }
    },
    async ensureWhatsAppReady() {
      try {
        const resp = await secureFetch(`${apiBaseUrl}/whatsapp-status`, { method: "GET" });
        const data = await resp.json();
        const uid = this.uidCache || (await getUid());

        const wasAuthed = this.whatsappAutenticado; // antes de mexer
        const isReady = data.status === "ready";
        const isReconnecting = data.status === "connecting" || data.status === "reconnecting";

        if (isReady) {
          localStorage.setItem(storageKey("qrCodeScanned", uid), "true");
          localStorage.setItem(storageKey("acessoComWhatsapp", uid), "true");
          this.waReadyFlag = true;
          return;
        }

        //  se já estava authed, não derruba por oscilação
        if (wasAuthed && isReconnecting) {
          this.waReadyFlag = true; 
          return;
        }

        // só derruba se o backend disser explicitamente "needs_qr" / "logged_out"
        if (data.status === "needs_qr" || data.status === "logged_out") {
          localStorage.setItem(storageKey("qrCodeScanned", uid), "false");
          localStorage.setItem(storageKey("acessoComWhatsapp", uid), "false");
          this.waReadyFlag = false;
        }
      } catch (e) {
        console.warn("ensureWhatsAppReady falhou:", e.message);
        // opcional: NÃO derrubar status aqui
      }
    },

    addNumber() {
      if (this.newNumber && this.newName) {
        const n55 = this.to55(this.newNumber);
        if (!n55) return;
        this.numbers.push({
          name: this.newName,
          number: n55,
          hasHistory: false,
          lastHistoryTs: null,
          checkingHistory: true,
          hasWhatsapp: null,
          checkingWhatsApp: true,
        });

        this.ensureValidPage();

        this.newNumber = "";
        this.newName = "";

        // checa em lote (debounce) ao inserir
        this.scheduleChecks();
      } else {
        this.statusMessage = "Por favor, preencha o nome e o número.";
        this.statusClass = "error";
      }
    },

    removeNumber(index) {
      this.numbers.splice(index, 1);
      this.ensureValidPage();
    },

    clearList() {
      if (this.numbers.length === 0) {
        this.statusMessage = "A lista já está vazia.";
        this.statusClass = "error";
        return;
      }

      if (
        confirm("Tem certeza que deseja remover todos os registros da lista?")
      ) {
        this.numbers = [];
        this.page = 1;
        this.statusMessage = "Lista de contatos limpa com sucesso!";
        this.statusClass = "success";
      }
    },

    importCSV() {
      const fileInput = document.getElementById("csvFile");
      fileInput.click();

      fileInput.onchange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
          const csvData = event.target.result;
          console.log("📂 CSV carregado:", csvData);
          this.processCSV(csvData);
        };

        reader.readAsText(file, "utf-8");
      };
    },

    // ✅ NOVO: função para processar o conteúdo do CSV
    processCSV(csvData) {
      this.rejectedCSVContacts = [];
      try {
        const sourceLineNumbers = csvData.split(/\r?\n/)
          .map((text, index) => ({ text, line: index + 1 }))
          .filter((entry) => entry.text.trim().length > 0)
          .map((entry) => entry.line);
        const lines = csvData
          .split(/\r?\n/)
          .map((l) => l.trim())
          .filter((l) => l.length > 0);

        if (lines.length === 0) {
          this.statusMessage = "O arquivo CSV está vazio.";
          this.statusClass = "error";
          return;
        }

        // Primeira linha = cabeçalho
        const headerLine = lines[0];
        const headers = headerLine
          .split(/[;,]/) // aceita ; ou ,
          .map((h) => h.trim().toLowerCase());

        let idxNome = headers.findIndex((h) =>
          h.includes("nome")
        );
        let idxNumero = headers.findIndex(
          (h) =>
            h.includes("número") ||
            h.includes("numero") ||
            h.includes("telefone") ||
            h.includes("celular")
        );

        // Se não tiver cabeçalho "bonito", assume 2 colunas: nome, numero
        const hasHeader =
          idxNome !== -1 && idxNumero !== -1 && lines.length > 1;

        if (!hasHeader && headers.length === 2) {
          idxNome = 0;
          idxNumero = 1;
        }

        if (idxNome === -1 || idxNumero === -1) {
          console.warn("Cabeçalho não reconhecido, usando primeira e segunda colunas.");
          idxNome = 0;
          idxNumero = 1;
        }

        const parsed = [];

        // Começa da linha 1 se tem header, senão da linha 0
        for (let i = hasHeader ? 1 : 0; i < lines.length; i++) {
          const cols = lines[i].split(/[;,]/).map((c) => c.trim());
          const name = cols[idxNome] || "";
          const number = cols[idxNumero] || "";

          if (!name && !number) continue;
          if (!number) {
            this.rejectedCSVContacts.push({ name, number, line: sourceLineNumbers[i], reason: "Telefone não informado." });
            continue;
          }
          
          const n55 = this.to55(number);
          if (!n55) {
            const digits = number.replace(/\D/g, "");
            const reason = !digits ? "Telefone sem dígitos válidos."
              : digits.startsWith("0800") ? "Números 0800 não são aceitos."
                : digits.startsWith("55") ? "Número iniciado em 55 interpretado como código do país, mas incompleto. Confira o DDD e o telefone."
                  : "Telefone incompleto. Informe o DDD e o número.";
            this.rejectedCSVContacts.push({ name, number, line: sourceLineNumbers[i], reason });
            continue;
          }

          parsed.push({
            name,
            number: n55,
            hasHistory: false,
            lastHistoryTs: null,
            checkingHistory: true,
            hasWhatsapp: null,
            checkingWhatsApp: true,
          });
        }

        if (!parsed.length) {
          this.statusMessage = "Nenhum contato válido encontrado no CSV.";
          this.statusClass = "error";
          return;
        }

        // Pode concatenar com o que já existe
        this.numbers = [...this.numbers, ...parsed];
        this.ensureValidPage();
        this.scheduleChecks();
        this.statusMessage = `✅ ${parsed.length} contato(s) importado(s) do CSV.`;
        this.statusClass = "success";
      } catch (err) {
        console.error("Erro ao processar CSV:", err);
        this.statusMessage = "Erro ao processar o arquivo CSV.";
        this.statusClass = "error";
      }
    },

    selectImage() {
      this.$refs.imageInput.click();
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const max = 8 * 1024 * 1024; // tem que bater com o backend
      if (file.size > max) {
        this.statusMessage = "Imagem muito grande. Envie uma imagem menor (até 8MB).";
        this.statusClass = "error";
        event.target.value = "";
        return;
      }

      this.imageFile = file;
      const reader = new FileReader();
      reader.onload = (e) => (this.imagePreview = e.target.result);
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.imageFile = null;
      this.imagePreview = null;
      if (this.$refs.imageInput) this.$refs.imageInput.value = "";
    },

    // ✅ NOVO: remove áudio gravado (usado no template e no sendMessage)
    removeAudio() {
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        try {
          this.mediaRecorder.stop();
        } catch (e) {
          console.warn("Erro ao parar mediaRecorder:", e);
        }
      }
      this.audioBlob = null;
      this.audioPreview = null;
      this.audioChunks = [];
    },

    async loadDailyRemaining() {
      this.dailyRemainingLoading = true;

      try {
        const resp = await secureFetch(`${apiBaseUrl}/daily-limit`, { method: "GET" });
        const data = await resp.json();

        if (data?.success && data?.limit?.remaining != null) {
          this.dailyRemaining = Number(data.limit.remaining);
        } else {
          // fallback visual: se algo der errado, mostra 200 mas com aviso
          this.dailyRemaining = this.dailyLimit;
          console.warn("daily-limit sem remaining:", data);
        }
      } catch (e) {
        console.warn("Falha ao carregar dailyRemaining:", e.message);
        this.dailyRemaining = this.dailyLimit; // fallback
      } finally {
        this.dailyRemainingLoading = false;
      }
    },

    async sendMessage() {
      const withoutWhatsapp = this.numbers.filter((n) => n.hasWhatsapp === false);
      const withWhatsapp = this.numbers.filter((n) => n.hasWhatsapp !== false);

      if (withoutWhatsapp.length) {
        this.statusMessage = `⚠️ ${withoutWhatsapp.length} número(s) não possuem WhatsApp e NÃO receberão mensagem.`;
        this.statusClass = "error"; // ou "info"
      }

      if (!withWhatsapp.length) {
        this.statusMessage = "⚠️ Nenhum número da lista possui WhatsApp. Nada será enviado.";
        this.statusClass = "error";
        return;
      }

      if (withWhatsapp.length > this.dailyRemaining) {
        this.statusMessage = `Você tem apenas ${this.dailyRemaining} envio(s) restante(s) hoje para este vendedor.`;
        this.statusClass = "error";
        return;
      }

      if (!this.message && !this.imageFile && !this.audioBlob) {
        this.statusMessage = "Por favor, insira uma mensagem, imagem ou áudio!";
        this.statusClass = "error";
        return;
      }

      if (this.interval < 4) {
        this.statusMessage = "O intervalo deve ser de pelo menos 4 segundos!";
        this.statusClass = "error";
        return;
      }

      this.isSending = true;
      this.statusClass = "info";

      try {
        const messagesToSend = withWhatsapp.map((contact) => ({
          number: contact.number,
          name: contact.name,
          message: (this.message || "").replace(/{nome}/g, contact.name || "Cliente"),
        }));

        const intervalInMilliseconds = Number(this.interval) * 1000;

        const formData = new FormData();
        formData.append("messages", JSON.stringify(messagesToSend));
        formData.append("mode", "bulk");
        formData.append("baseIntervalMs", String(intervalInMilliseconds));

        if (this.imageFile) {
          formData.append("image", this.imageFile);
          console.log("🖼️ Imagem anexada:", this.imageFile);
        }

        if (this.audioBlob) {
          formData.append("audio", this.audioBlob, "audio.webm");
          console.log("🎙️ Áudio anexado:", this.audioBlob);
        }

        console.log("📨 Enviando requisição para backend...");
        const response = await secureFetch(`${apiBaseUrl}/send-messages`, {
          method: "POST",
          body: formData,
        });

        //const contentType = response.headers.get("content-type") || "";
        const raw = await response.text();

        let data = null;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          // backend deveria sempre mandar JSON agora
          console.error("❌ Body não é JSON:", raw.slice(0, 800));
          throw new Error("Servidor retornou HTML/erro (não JSON). Verifique /send-messages no backend.");
        }

        if (data?.response?.code === "WHATSAPP_SESSION_EXPIRED") {
          alert("Sessão do whatsapp expirada. Faça login novamente");

          logout();
          return;
        }

        // Atualiza daily remaining sempre que vier
        if (data?.limit?.remaining != null) {
          this.dailyRemaining = Number(data.limit.remaining);
          this.dailyRemainingLoading = false;
        }

        // Helper: monta listas para modal
        const buildModalLists = (backendResponses, sentContacts) => {
          const successPhones = new Set(
            (backendResponses || [])
              .filter((r) => r?.success === true)
              .map((r) => String(r.numberCliente || "").replace(/\D/g, ""))
              .filter(Boolean)
          );

          const failList = (backendResponses || [])
            .filter((r) => r?.success === false)
            .map((r) => ({
              number: String(r.numberCliente || "").replace(/\D/g, ""),
              error: r.error || "",
            }))
            .filter((x) => x.number);

          const successList = (sentContacts || [])
            .map((c) => ({
              name: c.name,
              number: String(c.number || "").replace(/\D/g, ""),
            }))
            .filter((c) => successPhones.has(c.number));

          // fallback se backend não trouxe responses
          if (!backendResponses || backendResponses.length === 0) {
            return {
              successList: (withWhatsapp || []).map((c) => ({
                name: c.name,
                number: String(c.number || "").replace(/\D/g, ""),
              })),
              failList: [],
            };
          }

          return { successList, failList };
        };

        const backendResponses = data?.response?.responses || [];
        const sentContacts = [...this.numbers];

        // Se deu erro HTTP, mas backend devolveu responses, abre modal e mostra parcial
        if (!response.ok) {
          if (backendResponses.length) {
            const { successList, failList } = buildModalLists(backendResponses, sentContacts);
            this.sentSuccessList = successList;
            this.sentFailList = failList;
            this.showSentModal = true;

            this.statusMessage = `⚠️ Envio finalizou com erros (HTTP ${response.status}). Veja detalhes no resumo.`;
            this.statusClass = "warn";
          }

          const msg = data?.message || `Falha HTTP ${response.status}`;
          throw new Error(msg);
        }

        // OK HTTP, mas pode ser sucesso parcial
        if (data?.success) {
          const { successList, failList } = buildModalLists(backendResponses, sentContacts);

          this.sentSuccessList = successList;
          this.sentFailList = failList;
          this.showSentModal = true;

          if (failList.length > 0) {
            this.statusMessage = `⚠️ Envio concluído com falhas (${failList.length}). Veja detalhes no resumo.`;
            this.statusClass = "warn";
          } else {
            this.statusMessage = "✅ Mensagens enviadas com sucesso!";
            this.statusClass = "success";
          }

          // limpa mídias
          if (typeof this.removeImage === "function") this.removeImage();
          if (typeof this.removeAudio === "function") this.removeAudio();

          // kanban + limpa tela
          const lastMessageText = this.message;

          this.$emit("clear-prepared-contacts");
          this.contatosJaUsados = true;

          this.numbers = [];
          this.newName = "";
          this.newNumber = "";
          this.message = "";

          sentContacts.forEach((contact) => {
            this.$emit("add-card-to-kanban", {
              columnName: "ATENDIMENTO INICIADO",
              name: contact.name,
              phone: contact.number,
              lastMessage: lastMessageText,
              lastMessageTime: new Date().toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
              }),
              profilePicture: `https://ui-avatars.com/api/?name=${encodeURIComponent(contact.name)}`,
            });
          });

          console.log("✅ Cards adicionados ao Kanban!");
          return;
        }

        // Resposta inesperada
        console.error("⚠️ Resposta inesperada do backend:", data);
        this.statusMessage = data?.message || "⚠️ Resposta inesperada do servidor.";
        this.statusClass = "error";
      } catch (error) {
        console.error("Erro ao enviar a mensagem:", error);
        this.statusMessage = `Erro ao enviar a mensagem: ${error.message}`;
        this.statusClass = "error";
      } finally {
        this.isSending = false;
      }
    },
  },
};
</script>


<style src="@/assets/styles.css"></style>

<style scoped>
.csv-rejections {
  margin: 16px 0;
  padding: 14px 16px;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  background: #fff7ed;
  color: #7c2d12;
  font-size: 13px;
}
.csv-rejections summary { cursor: pointer; font-weight: 600; }
.csv-rejections p { margin: 10px 0; }
.csv-rejections__scroll { max-height: 280px; overflow: auto; }
.csv-rejections__table { width: 100%; border-collapse: collapse; text-align: left; }
.csv-rejections__table th,
.csv-rejections__table td { padding: 9px; border-bottom: 1px solid #fed7aa; vertical-align: top; }
.csv-rejections__table td { overflow-wrap: anywhere; }

.contact-analysis {
  margin: 16px 0;
  padding: 14px 16px;
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  background: #f5f8fc;
  color: #334155;
}
.contact-analysis__heading,
.contact-analysis__details {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-size: 13px;
}
.contact-analysis__heading strong {
  margin-right: auto;
}
.contact-analysis__progress {
  display: block;
  width: 100%;
  height: 10px;
  margin: 12px 0;
  overflow: hidden;
  border: 0;
  border-radius: 8px;
  background: #e2e8f0;
  accent-color: #2563eb;
}
.contact-analysis__progress::-webkit-progress-bar {
  background: #e2e8f0;
  border-radius: 8px;
}
.contact-analysis__progress::-webkit-progress-value {
  background: #2563eb;
  border-radius: 8px;
}
.contact-analysis__progress::-moz-progress-bar {
  background: #2563eb;
  border-radius: 8px;
}
.contact-analysis__spinner {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border: 2px solid #cbd5e1;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: contact-analysis-spin 0.8s linear infinite;
}
.contact-analysis__hint {
  margin: 10px 0 0;
  font-size: 12px;
  color: #64748b;
}
@keyframes contact-analysis-spin {
  to { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .contact-analysis__spinner { animation: none; }
}
</style>
